import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Notification from 'components/Notification';
import NotificationIcon from 'components/NotificationIcon';
import NotificationsScroll from 'components/NotificationsScroll';
import event from 'utils/event';

import notificationActions from '../../store/notification/actions';
import notViewedNotifications from '../../store/notification/selectors/notViewedNotifications';
import authedUser from '../../store/user/selectors/authedUser';

import {
  NotificationsItem,
  NotificationsContainer,
  StyledNotificationsDropdown,
} from './NotificationsDropdown.styles';
import exclamationCircleSVG from "../../assets/exclamation_circle.svg";

export class NotificationsDropdown extends Component {
  notificationIconClick = () => {
    event(`notification-icon-click`, [`click`, `notification-icon`, `${this.props.notifications.length}`]);
  }

  render() {
    const {
      user,
      notifications,
      clickNotification,
      isAuthenticated,
    } = this.props;

    const notificationsArr = notifications.reduce((items, notification) => {
      return [...items,
        <NotificationsItem
          key={ notification.id }
          onClick={(e) => e.stopPropagation()}
        >
          <Notification
            notification={ notification }
            user={ user }
            isStatic={ notification.isStatic ? notification.isStatic : false}
            clickNotification={ clickNotification }
            renderedInMenu
          />
        </NotificationsItem>,
      ];
    }, [<NotificationsItem key="notifications" >
      <Notification
        notification={{
          image: `data:image/svg+xml;utf8,${exclamationCircleSVG}`,
          goToLink: `/notifications`,
          text: `You have ${notifications.length} new notifications. `,
          regularText: `See page for all notifications`,
        }}
        user={ user }
        isStatic
        renderedInMenu
      />
    </NotificationsItem>]);

    return (
      <StyledNotificationsDropdown
        onClick={ this.notificationIconClick }
        items={<NotificationsScroll>{notificationsArr}</NotificationsScroll>}
        CustomMenu={ NotificationsContainer }
      >
        <NotificationIcon
          displayCount={ notifications.length }
          loggedIn={ isAuthenticated }
        />
      </StyledNotificationsDropdown>
    );
  }
}

NotificationsDropdown.propTypes = {
  user: PropTypes.object,
  clickNotification: PropTypes.func,
  notifications: PropTypes.array.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

export default connect((state) => {
  return {
    user: authedUser(state),
    notifications: notViewedNotifications(state),
  };
}, {
  clickNotification: notificationActions.clickNotification,
})(NotificationsDropdown);
